import {
  FUNDRAISING,
  OTHER_FINANCING_SOLUTIONS,
  PAYMENT_TRANSACTIONS,
  PROFESSIONAL_EVENTS,
  INVESTMENT_LOAN_TERM_IN_YEARS,
  FUNDING_CLOSING_DATE,
} from 'modules/Inquiry/Form/formFields';
import { fieldParsers } from 'modules/Inquiry/mapInquiryToApi/fieldParsers';
import { InquiryFormMapper } from 'modules/Inquiry/mapInquiryToApi/InquiryFormMapper.model';

import { pushSelectedFlagInArray } from '../utils';

const { toInteger } = fieldParsers;

const getFurtherNeeds = (allFields: any) => {
  const furtherNeeds: any[] = [];
  pushSelectedFlagInArray(allFields, furtherNeeds, PAYMENT_TRANSACTIONS);
  pushSelectedFlagInArray(allFields, furtherNeeds, PROFESSIONAL_EVENTS);
  pushSelectedFlagInArray(allFields, furtherNeeds, FUNDRAISING);
  pushSelectedFlagInArray(allFields, furtherNeeds, OTHER_FINANCING_SOLUTIONS);
  return furtherNeeds;
};

export const mapBFSProductDetailsToApi: InquiryFormMapper = (allFields) => {
  const furtherNeeds = getFurtherNeeds(allFields);
  return {
    'further-need-values': furtherNeeds,
    'loan-term-in-years': toInteger(allFields[INVESTMENT_LOAN_TERM_IN_YEARS]),
    'funding-closing-date': allFields[FUNDING_CLOSING_DATE],
    'desired-delivery-date': allFields[FUNDING_CLOSING_DATE],
    // "Weiterer Bedarf" is optional (EBS-38); derive the boolean from the selection.
    further_need: furtherNeeds.length > 0,
  };
};
